import API from '.';

export default class costObjectType {
  /**
   * The costObjectType dimension table for UDM
   * @param {number} costObjectTypeId Id of the costObjectType.
   * @param {string} costObjectTypeName Name of the costObjectType.
   * @param {string} costObjectTypeDesc Description of the costObjectType.
   */
  //costObjectTypeCode?
  constructor({ costObjectTypeId, costObjectTypeName, costObjectTypeDesc }) {
    this.costObjectTypeId = costObjectTypeId;
    this.costObjectTypeName = costObjectTypeName;
    this.costObjectTypeDesc = costObjectTypeDesc;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/costObjectType');
    return data.map((d) => new costObjectType(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`costObjectType/${id}`);
    return new costObjectType(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('costObjectType', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/costObjectType`, data);
  //   return res;
  // }
}
